import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-dialog',
	templateUrl: './dialog.html'
})
export class AlertDialogComponent {

	@Input() message: string = null;
	@Input() confirm: boolean = false;

	constructor(public activeModal: NgbActiveModal) { }

	setMessage(msg) {
		this.message = msg;
	}

	setConfirm(conf) {
		this.confirm = conf;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/dialog/dialog.ts